module.exports = __webpack_public_path__ + "static/media/card_bg_6.feb2e2b6.png";